import React from "react";

import { appConstants } from "../../config/app-constants";

type Props = {};

const HRAAllowanceHint: React.FC<Props> = (props: Props) => {
	return (
		<>
			<section className="text-center">
				<img
					src={`${appConstants.basePath}/assets/images/hints/hra-allowance.png`}
					alt="HRA"
					className="img-fluid d-block mx-auto my-4"
				/>
			</section>
		</>
	);
};

export default HRAAllowanceHint;
